import React from "react";
import { numberToDollarStr } from "../../../../../../../../utils/commonFunctions/dollar";

import "./enrollmentInsights.css";
import { EnrollmentInsightProps } from "../../../../../../../../@types/components/enrollmentTabSection.types";

const EnrollmentInsights: React.FC<EnrollmentInsightProps> = ({
	totalPremium,
	totalEligibleEmployees,
	totalActiveBenefit,
	totalSubmittedEnrollment,
	totalWaivedEnrollment
}) => {
	return (
		<div className="enrollment-insights">
			{/* <div className="total-information-container">
				<div className="total-information-label">Total Premium of All Health Plan</div>
				<div className="total-information-value">{numberToDollarStr(totalPremium)}</div>
			</div> */}
			<div className="total-information-container">
				<div className="total-information-label">Total Eligible Employees</div>
				<div className="total-information-value">{totalEligibleEmployees}</div>
			</div>
			<div className="total-information-container">
				<div className="total-information-label">Total Active Benefits</div>
				<div className="total-information-value">{totalActiveBenefit}</div>
			</div>
			<div className="total-information-container">
				<div className="total-information-label">Total Submitted Enrollments</div>
				<div className="total-information-value">{totalSubmittedEnrollment}</div>
			</div>
			<div className="total-information-container">
				<div className="total-information-label">Total Waived Enrollments</div>
				<div className="total-information-value">{totalWaivedEnrollment}</div>
			</div>
		</div>
	);
};

export default EnrollmentInsights;
